import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { Router } from "@angular/router";
import { Prelaunch } from "src/app/core/models/prelaunch.model";
import { PrelaunchService } from "src/app/core/services/prelaunch.service";
import { VERSION } from "src/environments/version";

@Component({
  selector: "hydrao-maintenance-mode",
  templateUrl: "./maintenance-mode.component.html",
  styleUrl: "./maintenance-mode.component.scss",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatCardModule],
})
export class MaintenanceModeComponent {
  private _prelaunchService: PrelaunchService = inject(PrelaunchService);
  private _router: Router = inject(Router);

  public get version() {
    return VERSION.version;
  }

  public get hash() {
    return VERSION.hash;
  }

  public get branch() {
    return VERSION.branch;
  }

  constructor() {
    this._prelaunchService.check().subscribe((prelaunch: Prelaunch) => {
      if (!prelaunch.maintenance) {
        this._router.navigate(["/"], { replaceUrl: true });
      }
    });
  }
}
